import { getListName } from 'analytics/enhanced-ecommerce'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import { OfferListEventsProvider } from 'components/OfferList/OfferListEventsContext'
import Places from 'constants/places'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'
import { getSearchQueryFromFilter } from 'lib/search/searchUtils'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { LUX_PLUS_MONTH_CAMPAIGN_ID } from 'takeovers/luxPlusMonthTakeover/constants/luxPlusMonthTakeoverConstants'

const FILTERS: App.OfferListFilters = {
  offerTypes: ['hotel', 'tactical_ao_hotel'],
  luxPlusFeatures: ['Member prices'],
  campaigns: [LUX_PLUS_MONTH_CAMPAIGN_ID],
  destinations: [Places.Anywhere.id],
  sortBy: 'luxPlusList',
  limit: 20,
}

const ALL_LINK = `/search?${getSearchQueryFromFilter(FILTERS)}`

interface Props {
  analyticsPage: string
}

function LuxPlusMonthHotelsOfferCarousel({ analyticsPage }: Props) {
  const tracking = useOfferListTracking(getListName('OfferList', analyticsPage, 'Member'))

  return <OfferListEventsProvider tracking={tracking}>
    <OfferCardCarouselSection
      tileSize="medium"
      title={<FormattedMessage
        id="0qXj1D1X7oS4xs-g1e-R"
        defaultMessage="<i>More savings</i> on our best hotel offers"
        description="Carousel title for LuxPlus+ Month hotel offers with member savings"
        values={{ i: (chunks) => <i>{chunks}</i> }}
      />}
      filters={FILTERS}
      allLink={ALL_LINK}
      hideWhenEmpty
      id="discounted_flash"
    />
  </OfferListEventsProvider>
}

export default LuxPlusMonthHotelsOfferCarousel
